import { Button, Typography, withStyles } from "@material-ui/core";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import style from "style";
const TITLE_DEFAULT_COLOR = "#b2006f";
const SUBTEXT_DEFAULT_COLOR = "#542785";
const HeaderText = ({ headerText, subText }): ReactNode => {
  return (
    <div
      className="flex-direction-column center"
      style={{ height: "fit-content" }}
    >
      <div style={{ padding: "0 45px" }}>
        <Typography
          style={{
            color: TITLE_DEFAULT_COLOR,
            fontSize: 28,
            fontWeight: "600",
            textAlign: "center",
          }}
          dangerouslySetInnerHTML={{
            __html: headerText,
          }}
        />
        <Typography
          style={{
            color: SUBTEXT_DEFAULT_COLOR,
            fontSize: 28,
            fontWeight: "600",
            textAlign: "center",
          }}
          dangerouslySetInnerHTML={{
            __html: subText,
          }}
        />
      </div>
    </div>
  );
};

const BannerDetailsForMobile = ({
  classes,
  headerText,
  subText,
  title_color,
  subtext_color,
  trackBannerClick,
  copy,
  ...banner
}): ReactNode => {
  return (
    <div
      className="flex-direction-column "
      style={{
        height: "fit-content",
        minHeight: 200,
        padding: 10,
      }}
    >
      <HeaderText
        headerText={headerText}
        subText={subText}
        subtext_color={subtext_color}
        title_color={title_color}
      />
      {copy !== "" && (
        <Typography
          variant="h5"
          style={{
            textAlign: "center",
            lineHeight: "1",
          }}
        >
          <span
            className={classes.smallerFont}
            dangerouslySetInnerHTML={{
              __html: copy,
            }}
          />
        </Typography>
      )}{" "}
      <br />
      {banner.cta !== "" && (
        <div
          style={{
            textAlign: "center",
          }}
        >
          {banner.field_link_type === "External" ? (
            <Button
              href={banner.link}
              size="medium"
              variant="contained"
              color="secondary"
              onClick={trackBannerClick}
            >
              {banner.cta}
            </Button>
          ) : (
            <Button
              component={Link}
              to={banner.link}
              size="medium"
              variant="contained"
              onClick={trackBannerClick}
              color="secondary"
            >
              {banner.cta}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default withStyles(style)(BannerDetailsForMobile);
